import RegisterCard from "@/components/auth/RegisterCard";
import FavIconsMeta from "@/components/FavIconsMeta";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Button } from "@/components/ui/button";
import { CardDescription, CardTitle } from "@/components/ui/card";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { useToast } from "@/components/ui/use-toast";
import { useDarkTheme } from "@/contexts/DarkTheme";
import { useIsMobile } from "@/helpers/helperFunctions";
import { cn } from "@/lib/utils";
import axios from "axios";
import type { GetStaticProps, NextPage } from "next";
import { getSession } from "next-auth/react";
import { useTranslation } from "next-i18next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { NextSeo } from "next-seo";
import { Inter } from "next/font/google";
import Head from "next/head";
import Image from "next/image";
import Link from "next/link";
import { useRouter } from "next/router";
import { useEffect, useMemo, useState } from "react";
import { BsGlobe } from "react-icons/bs";
import { FaApple } from "react-icons/fa";
import { useRecoilState } from "recoil";
import { authFormState } from "../Atoms/auth/AuthFormState";
import { API_URL, AppConfig } from "../config";
import {
  BROKER_LOGO,
  CURRENT_BROKER,
  CURRENT_SERVER_URL,
} from "@/config/logos";

const inter = Inter({ subsets: ["latin"] });

const Home: NextPage = (props: any) => {
  const { toast } = useToast();
  const router = useRouter();
  const [formState, setFormState] = useRecoilState(authFormState);
  const [visible, setVisible] = useState(true);
  const [show, setShow] = useState(false);
  const [showLanguageMenu, setShowLanguageMenu] = useState<boolean>(false);
  const [enabledSwitch, setEnabledSwitch] = useState(
    router.query.locale || "en"
  );
  const isMobile = useIsMobile(false);
  const { darkTheme } = useDarkTheme();
  const { t } = useTranslation("common");
  const { t: ct } = useTranslation("layout");
  let count = 0;
  const selectedLanguage = useMemo(
    () => router.query.locale || enabledSwitch,
    [router.query.locale, enabledSwitch]
  );
  const languagesOptions = useMemo(() => {
    return [
      {
        name: ct("header.chinese"),
        value: "zh",
      },
      {
        name: ct("header.english"),
        value: "en",
      },
      {
        name: ct("header.german"),
        value: "de",
      },
      {
        name: ct("header.italian"),
        value: "it",
      },
      {
        name: ct("header.portuguese"),
        value: "pt",
      },
      {
        name: ct("header.spanish"),
        value: "es",
      },
    ];
  }, [t]);

  useEffect(() => {
    if (props?.user !== null) {
      if (localStorage && props?.user?.user) {
        localStorage.setItem("user-info", JSON.stringify(props?.user));
        localStorage.setItem("userAuthenticated", "true");
        // if (
        //   props?.user.subscription &&
        //   props?.user.subscription == "inactive"
        // ) {
        //   router.push(`/subscription?locale=${router.query.locale || "en"}`);
        // }
        router.push(`/build?locale=${router.query.locale || "en"}`);
      }
    }
  }, []);
  const toastMessage = (status: boolean, message: string) => {
    if (status == true) {
      toast({
        title: message,
      });
      return;
    } else {
      toast({
        title: message,
        variant: "destructive",
      });
    }
    // throw new Error(message);
  };

  const toggleVisible = () => {
    const scrolled = document.documentElement.scrollTop;
    if (scrolled > 0) {
      setVisible(false);
    } else if (scrolled <= 0) {
      setVisible(true);
    }
  };

  const scrollToBottom = () => {
    const section: any = document.getElementById("createForm");
    section.scrollIntoView({ behavior: "smooth", block: "start" });
  };
  useEffect(() => {
    window.addEventListener("scroll", toggleVisible);
  }, []);
  const custom_button = (
    <div className="flex justify-center">
      <div className="flex lg:flex-row flex-col gap-4 mt-4">
        <a
          target="_blank"
          rel="noreferrer"
          className="button flex items-center font-semibold border border-primary p-1 rounded-sm"
          href="https://apps.apple.com/in/app/bytemine/id1568477262"
        >
          <FaApple className="mr-2" size={35} />
          <span className="flex flex-col  text-2xl">
            <span className="text-xs font-normal">
              {t("index.availableOnThe")}
            </span>
            {t("index.appStore")}
          </span>
        </a>
        <a
          target="_blank"
          rel="noreferrer"
          className="button flex items-center font-semibold border border-primary p-1 rounded-sm"
          href="https://play.google.com/store/apps/details?id=com.bytemine&hl=en_IN&gl=US"
        >
          <Image src="/images/playstore.png" height={30} width={30} alt="" />
          <span className="flex flex-col ml-2 text-2xl">
            <span className="text-xs font-normal">{t("index.getItOn")}</span>
            {t("index.googlePlay")}
          </span>
        </a>
      </div>
    </div>
  );
  return (
    <>
      <Head>
        {process.env.NODE_ENV === "production" ? (
          <meta name="robots" content="index,follow" />
        ) : (
          <meta name="robots" content="noindex,nofollow" />
        )}
        <meta charSet="UTF-8" key="charset" />
        <meta
          name="viewport"
          content="width=device-width,initial-scale=1.0, maximum-scale=1.0, user-scalable=0"
          key="viewport"
        />

        {/* <link rel="manifest" href={`${router.basePath}/site.webmanifest`} /> */}
        {/* <link
          href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css"
          rel="stylesheet"
        /> */}
        {/* <link rel="mask-icon" href="/safari-pinned-tab.svg" color="#5bbad5" /> */}
        <FavIconsMeta />
        <link
          rel="stylesheet"
          href="https://rsms.me/inter/inter.css"
          key="inter-font"
        />
      </Head>
      <NextSeo
        title={AppConfig.title}
        description={AppConfig.description}
        openGraph={{
          locale: AppConfig.locale,
          site_name: AppConfig.site_name,
        }}
      />

      <Dialog open={show} onOpenChange={(open) => setShow(!show)}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>
              {t(
                "The first automated trading platform you'll love. And the last one you'll ever need."
              )}
            </DialogTitle>
          </DialogHeader>
          <div className="w-full flex justify-center items-center h-full">
            <div className="flex flex-col text-center gap-4 justify-center  h-full w-full max-w-md">
              <iframe
                className="w-full"
                src="https://player.vimeo.com/video/938194814?h=921bdd3d2d"
                width="320"
                height="300"
                allow="autoplay; fullscreen; picture-in-picture"
                allowFullScreen
              ></iframe>
              <CardDescription>
                {t(
                  "Welcome to Plus100, the first fully-visual strategy creation tool built for technical traders."
                )}
              </CardDescription>
              <CardDescription>
                {t(
                  "Join us for 30-day free trial and by the end, you'll have created your own, automated trading strategies that bring your ideas to life."
                )}
              </CardDescription>
              <CardDescription>
                {t(
                  "Elevate your trading game with Plus100. No code, No limits."
                )}
              </CardDescription>
              <Button
                onClick={() => {
                  setShow(!show);
                  scrollToBottom();
                }}
                className="!bg-[#254285]"
              >
                {t("Get started")}
              </Button>
            </div>
          </div>
        </DialogContent>
      </Dialog>

      <div className="relative ">
        <div
          className="flex absolute z-10 right-1 top-12 justify-center items-center"
          id="languageMenu"
        >
          <DropdownMenu
            open={showLanguageMenu}
            onOpenChange={(open) => setShowLanguageMenu(open)}
          >
            <DropdownMenuTrigger asChild>
              <div className="flex flex-col">
                <BsGlobe
                  className={cn(
                    "cursor-pointer",
                    isMobile ? "!text-[#ffff]" : ""
                  )}
                  size={12}
                  onClick={() => {
                    setShowLanguageMenu(true);
                  }}
                />
              </div>
            </DropdownMenuTrigger>
            <DropdownMenuContent className="w-52" sideOffset={20}>
              <DropdownMenuLabel>
                {ct("header.PlatformLanguage")}
              </DropdownMenuLabel>
              <DropdownMenuSeparator />
              <DropdownMenuGroup>
                <div className="flex flex-col gap-2 px-2">
                  {languagesOptions.map((lang, index) => {
                    const isSelected = lang.value === selectedLanguage;
                    return (
                      <div
                        className="flex flex-row items-center justify-between gap-2"
                        key={index}
                      >
                        <Label htmlFor={"lang-box-" + lang.value}>
                          {lang.name}
                        </Label>
                        <Switch
                          id={"lang-box-" + lang.value}
                          checked={isSelected}
                          disabled={isSelected}
                          onCheckedChange={() => {
                            setEnabledSwitch(lang?.value || "en");
                            router.query.locale = lang?.value || "en";
                            router.push(router);
                          }}
                        />
                      </div>
                    );
                  })}
                </div>
              </DropdownMenuGroup>
            </DropdownMenuContent>
          </DropdownMenu>
        </div>
        <div className="w-full flex">
          <div className="w-full hidden lg:opacity-1 lg:block bg-tl2-blue-extradark"></div>
          {/* <div className="py-2 w-full hidden md:block bg-[#254285] text-center text-primary-foreground">
            <a
              href="https://partner.blofin.com/d/Plus100"
              className="underline"
              target="_blank"
            >
              {t("$30 sign up bonus for new crypto traders")}
            </a>
          </div> */}
        </div>
        <div
          className={cn(
            "relative md:h-screen  md:mt-[0px] flex-col items-center justify-center md:grid lg:max-w-none lg:grid-cols-2 lg:px-0",
            !isMobile ? "container" : "first-line:"
          )}
        >
          {isMobile && (
            <>
              <div className="relative !min-h-[100dvh] bg-tl2-blue-extradark !w-screen">
                {/* <div className="py-2 w-full absolute bg-[#254285] text-center text-primary-foreground">
                  <a
                    href="https://partner.blofin.com/d/Plus100"
                    className="underline"
                    target="_blank"
                  >
                    {t("$30 sign up bonus for new crypto traders")}
                  </a>
                </div> */}
                <video
                  className="!h-full !w-full"
                  playsInline
                  autoPlay
                  loop
                  muted
                >
                  <source src="/register-page-vedio.mp4" type="video/mp4" />
                </video>
                <div className="absolute px-3 py-4 gap-3 bottom-1 w-full grid grid-cols-2">
                  <div
                    onClick={scrollToBottom}
                    className={cn(
                      "px-5 py-3 w-full text-center flex flex-col gap-2 bg-[#254285] rounded-lg "
                    )}
                  >
                    <CardTitle className="text-white text-xl  whitespace-nowrap">
                      {t("Register now")}
                    </CardTitle>
                    <CardDescription className="text-white text-sm text-muted-foreground">
                      {t(
                        "Create strategies using our simple dag-and-drop approach"
                      )}
                    </CardDescription>
                  </div>
                  <div
                    onClick={() => setShow(true)}
                    className={cn(
                      "px-5 py-3 w-full text-center flex flex-col gap-2 bg-[#254285] rounded-lg "
                    )}
                  >
                    <CardTitle className="text-white text-xl whitespace-nowrap">
                      {t("Find out more")}
                    </CardTitle>
                    <CardDescription className="text-white text-sm text-muted-foreground">
                      {t(
                        "Find out how to Elevate your trading with Plus100. No coding required"
                      )}
                    </CardDescription>
                  </div>
                </div>
              </div>
              <div className="flex flex-col gap-4 justify-center items-center text-center px-8 pt-4">
                {/* <Link href="https://trylevel2.com/">
                <Avatar className="rounded-none mx-auto w-fit h-fit">
                  <AvatarImage
                    src={
                      darkTheme
                        ? "/images/logos/Plus100.png"
                        : "/images/logos/Logo_Light-2.png"
                    }
                    className="aspect-auto max-h-10 sm:max-w-[300px] flex mb-3 lg:hidden object-contain"
                    alt=""
                  />
                  <AvatarFallback className="text-3xl font-bold bg-transparent">
                    Plus100
                  </AvatarFallback>
                </Avatar>
              </Link> */}
              </div>
            </>
          )}

          <div className="relative hidden h-full flex-col bg-muted p-10 lg:flex">
            <div className="absolute flex justify-center items-center inset-0 bg-tl2-blue-extradark">
              <div className="flex flex-col text-center gap-6 justify-center  h-full w-full max-w-md">
                <CardTitle className="text-lg text-center !text-[#fff]">
                  {t(
                    "The first automated trading platform you'll love. And the last one you'll ever need."
                  )}
                </CardTitle>
                <iframe
                  className="w-full"
                  src="https://player.vimeo.com/video/938194814?h=921bdd3d2d"
                  width="320"
                  height="300"
                  allow="autoplay; fullscreen; picture-in-picture"
                  allowFullScreen
                ></iframe>
                <CardDescription>
                  {t(
                    "Welcome to Plus100, the first fully-visual strategy creation tool built for technical traders."
                  )}
                </CardDescription>
                <CardDescription>
                  {t(
                    "Join us for 30-day free trial and by the end, you'll have created your own, automated trading strategies that bring your ideas to life."
                  )}
                </CardDescription>
                <CardDescription>
                  {t(
                    "Elevate your trading game with Plus100. No code, No limits."
                  )}
                </CardDescription>
                {/* <div className="flex gap-2 items-start">
                  <Settings className="h-5 w-5 text-white mt-1" />
                  <div>
                    <span className="text-primary-foreground">
                      {t("Smarter Trading")}
                    </span>
                    <CardDescription>
                      {t(
                        "Leverage automation to identify patterns, spot opportunities, and mitigate risks"
                      )}
                    </CardDescription>
                  </div>
                </div>
                <div className="flex gap-2 items-start">
                  <LineChart className="h-5 w-5 text-white mt-1" />
                  <div>
                    <span className="text-primary-foreground">
                      {t("Data-Driven Decisions")}
                    </span>
                    <CardDescription>
                      {t(
                        "Make decisions that are informed and detached from emotional biases."
                      )}
                    </CardDescription>
                  </div>
                </div>
                <div className="flex gap-2 items-start">
                  <Workflow className="h-5 w-5 text-white mt-1" />
                  <div>
                    <span className="text-primary-foreground">
                      {t("Automated Risk Management")}
                    </span>
                    <CardDescription>
                      {t(
                        "Execute trades with disciplined precision using preset parameters."
                      )}
                    </CardDescription>
                  </div>
                </div>
                <div className="flex gap-2 items-start">
                  <Hourglass className="h-5 w-5 text-white mt-1" />
                  <div>
                    <span className="text-primary-foreground">
                      {t("Time Freedom")}
                    </span>
                    <CardDescription>
                      {t(
                        "Sleep easy knowing your trading strategy is at work even when you're not."
                      )}
                    </CardDescription>
                  </div>
                </div> */}
              </div>
            </div>

            <div className="relative z-20  flex items-center  text-lg font-medium">
              {/* <Link href="https://">
                <Image
                  width={115}
                  height={60}
                  src={
                    darkTheme
                      ? BROKER_LOGO[CURRENT_BROKER].DARK.textLogo
                      : BROKER_LOGO[CURRENT_BROKER].LIGHT.textLogo
                  }
                  className="md:max-h-[60px] xs:max-h-[25px] max-h-[25px] sm:max-w-[300px]"
                  alt=""
                />
              </Link> */}
              {/* Plus100 */}
            </div>
            <div className="relative z-20  flex justify-center">
              <blockquote className="space-y-2">
                {/* <p className="text-lg">
                &ldquo;This library has saved me countless hours of work and
                helped me deliver stunning designs to my clients faster than
                ever before.&rdquo;
              </p> */}
                {/* <footer className="text-sm">Sofia Davis</footer> */}
              </blockquote>
            </div>
          </div>
          <div className={cn("lg:p-8 ", isMobile ? " p-4 px-8" : "")}>
            <div
              className={cn(
                "mx-auto flex flex-col justify-center space-y-6 sm:w-[350px]",
                isMobile
                  ? "!min-h-[100dvh]"
                  : formState.view == "create"
                  ? "sm:w-[650px]"
                  : ""
              )}
              id="createForm"
            >
              {!isMobile && (
                <Link href={CURRENT_SERVER_URL}>
                  <Avatar className="rounded-none mx-auto w-fit h-fit">
                    <AvatarImage
                      src={
                        darkTheme
                          ? "/images/logos/Plus100.png"
                          : "/images/logos/Logo_Light-2.png"
                      }
                      className="aspect-auto max-h-10 sm:max-w-[300px] flex lg:hidden object-contain"
                      alt=""
                    />
                    <AvatarFallback className="text-3xl font-bold bg-transparent">
                      {/* Plus100 */}
                    </AvatarFallback>
                  </Avatar>
                </Link>
              )}

              <div className="flex flex-col space-y-2 text-center">
                <div className="flex justify-center items-center align-middle">
                  <div>
                    <h1 className="text-2xl font-semibold tracking-tight">
                      {t("Trade smarter with")}
                    </h1>
                  </div>
                  <div>
                    <Image
                      height={30}
                      width={100}
                      alt="rocket-icon"
                      className="ml-3 mt-2"
                      src={BROKER_LOGO[CURRENT_BROKER].LIGHT.textLogo}
                    />
                  </div>
                </div>

                <p className="text-sm text-muted-foreground">
                  {t("Register for 30-days free access.")} <br></br>
                  {t("No credit card required")}
                </p>
                {/* <p className="text-sm text-muted-foreground">
                Enter your email below to create your account
              </p> */}
              </div>

              <RegisterCard />
              {/* <UserAuthForm /> */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export const getStaticProps: GetStaticProps = async ({ locale }) => {
  return {
    props: {
      ...(await serverSideTranslations(locale || "en", ["common", "layout"])),
    },
    revalidate: 60, // ISR - Refresh translations every 60 seconds
  };
};
export default Home;
